import { Link, useLocation } from "react-router-dom"
import { SlArrowRight } from "react-icons/sl"
import { AiFillHome } from "react-icons/ai"

const routeNameMap: any = {
    cliente: "Clientes",
    produtos: "Produtos",
    marca: "Marcas",
    companies: "Empresas",
    empresas: "Empresas",
    grupo: "Grupos",
    subGrupo: "SubGrupos",
    naturezaOperacao: "Naturezas das operações",
    unidMedida: "Unidades de Medida",
    formaPagto: "Formas de Pagamento",
    tributacao: "Tributações",
    fornecedor: "Fornecedores",
    grupoDespesa: "Grupos de Despesa",
    sgrupoDespesa: "SubGrupos de Despesa",
    transportadora: "Transportadoras",
    serieDoc: "Séries dos Doc. Fiscais",
    parceiros: "Parceiros",
    contas: "Contas",

    login: "Login",
    profile: "Perfil",
    estoque: "Estoques",
    estoque_acerto: "Acertos de Estoque",
    new: "Cadastro",
    NEW: "Cadastro",
    New: "Cadastro",
    edit: "Editar",
    EDIT: "Editar",
    Edit: "Editar",
    dupli: "Duplicar",
    DUPLI: "Duplicar",
    Dupli: "Duplicar",
    estoque_movimentacao: "Movimentações de Estoque",
    entradaNota: "Entradas de Nota",
    saidaNota: "Saídas de Nota",
    configNF: "Configurações NF",
    lancamento: "Lançamentos",
    contaApagar: "Duplicatas a Pagar",
    contaAreceber: "Duplicatas a Receber",
    excluidas: "Excluídas",
    excluidos: "Excluídos",
    relatorios: "Relatórios",
    venda: "Vendas",
    c_contas: "Extratos de Conta",
    relatorios_itens: "Relatórios de Itens da Venda",
    relatorios_venda: "Relatórios de Venda",
    relatorios_resumo_vendas: "Resumos de Venda",
    c_contas_transferencia: "Transferência entre Contas",
    c_cheque: "Cheques",
    sup_sangria: "Lançamento de suprimento e sangria",
    rel_caixa_diario: "Relatório de Caixa",
    c_contas_new: "Lançamentos de Conta",
    c_contas_extrato: "Extratos das Contas",
    recibos: "Recibos",
    consulta: "Consultas",
    condicional: "Condicional",
    rel_estoque_produto: "Relatórios de Produtos em Estoque",
    bandeira: "Bandeiras",
    lanctoCartao: "Lançamento de Cartão"
}


const Breadcrumbs = () => {
    const location = useLocation()
    const pathnames = location.pathname.split("/").filter((x) => x)

    const handleMouseUp = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        // Desfocar o link após o clique
        const target = e.target as HTMLElement;
        if (target instanceof HTMLAnchorElement) {
            target.blur();
        }
    }

    const handleKeyDown = (e: React.KeyboardEvent<HTMLAnchorElement>) => {
        if (e.key === "Enter" || e.key === "NumpadEnter") {
            // Prevenir a ação padrão do Enter
            e.preventDefault();
        }
    };

    return (
        <nav className={`pl-3 pr-3 text-base text-slate-700 dark:text-slate-100 bg-white dark:bg-slate-600 border border-slate-300 dark:border-slate-800 shadow-sm shadow-indigo-200 dark:shadow-slate-800 h-8 flex justify-center items-center rounded-md`}>

            <div className={`w-full h-full flex items-center justify-center`}>
                <a tabIndex={-1} onMouseUp={handleMouseUp} onKeyDown={handleKeyDown} href="/"><AiFillHome /></a>

                {pathnames.length > 0 && <SlArrowRight className={`opacity-25 dark:text-black`} size={30} />}
            </div>

            {pathnames.map((name, index) => {
                if (!isNaN(Number(name)) || !routeNameMap[name]) {
                    // Ignorar números na rota
                    return null
                }

                const routeTo = `/${pathnames.slice(0, index + 1).join("/")}`
                const isLast = index === pathnames.length - 1
                const displayName = routeNameMap[name] || name

                return (
                    <div key={name} className={`w-auto h-full flex items-center justify-center whitespace-nowrap`}>

                        {!isLast && (
                            <span className={`w-full h-full flex items-center justify-center`}>

                                {index === 0 ? (
                                    <a tabIndex={-1} onMouseUp={handleMouseUp} onKeyDown={handleKeyDown} href={routeTo}>{displayName}</a>
                                ) : <span>{displayName}</span>
                                }

                                {index === 0 ? (
                                    <SlArrowRight className={`opacity-25 dark:text-black`} size={30} />
                                ) : ''}

                            </span>
                        )}

                        {isLast && displayName}
                    </div>
                )
            })}

        </nav>
    )
}

export default Breadcrumbs
